var _defs, _path, _path2, _path3;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgAttendeeCancelled = function SvgAttendeeCancelled(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 23.86 22.15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".attendee-cancelled-1{fill:none;stroke:#fe001e;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "attendee-cancelled-1",
    d: "M11.32,19.78a8.3,8.3,0,0,0,8.5-8.1,8.31,8.31,0,0,0-8.5-8.11,8.31,8.31,0,0,0-8.5,8.11A8.31,8.31,0,0,0,11.32,19.78Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-cancelled-1",
    d: "M14.09,9.31,8.56,14.05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "attendee-cancelled-1",
    d: "M8.56,9.31l5.53,4.74"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAttendeeCancelled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/AttendeeCancelled.699cf0c1.svg";
export { ForwardRef as ReactComponent };